/**
 * Single source for API base URL. Same as login and all other API calls.
 * - Local dev (npm start on localhost): http://localhost:8000.
 * - Production (.env.production): REACT_APP_API_URL=https://config-go.com (baked into build).
 * - Deployed on config-go.com without env: same origin (Nginx proxies /api).
 */
function getApiUrl() {
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname || '';
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:8000';
    }
  }

  const envUrl = process.env.REACT_APP_API_URL;
  if (typeof envUrl === 'string' && envUrl.trim() !== '') {
    return envUrl.trim().replace(/\/$/, '');
  }

  if (typeof window === 'undefined' || !window.location) {
    return '';
  }

  return window.location.origin;
}

export const API_URL = getApiUrl();
